export default "__VITE_ASSET__DnqHXob4__"